import { Layout } from './Layout';
import { Aside } from './Aside';
import { Main } from './Main';

export { Layout, Aside, Main };
export default Layout;
